import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { cdpClient } from '../client';
import type { Contact, ContactCreate, Postback } from '../types';

export const contactsAdapter: CrudAdapter<Contact & { id: string }, ContactCreate, never> = {
  async list({ offset, limit }) {
    const { data, error } = await cdpClient.GET('/contacts', {
      params: { query: { limit, offset } },
    });
    if (error) throw error;
    const items = (data?.items ?? []).map((c) => ({
      ...c,
      id: `${c.phone}|${c.message_id}`,
    }));
    return { items, total: data?.total ?? items.length };
  },
  async create(payload) {
    const { data, error } = await cdpClient.POST('/contacts', { body: payload });
    if (error) throw error;
    const phone = data?.phone ?? payload.phone;
    const messageId = data?.message_id ?? payload.message_id;
    return { id: `${phone}|${messageId}` };
  },
};

export const contactsStore = useCrudDataSource(contactsAdapter, { keyExpr: 'id' });

export async function fetchContactEvents(phone: string): Promise<Postback[]> {
  const { data, error } = await cdpClient.GET('/contacts/{phone}', {
    params: { path: { phone } },
  });
  if (error) throw error;
  return (data?.events ?? []).map((row) => ({
    ...row,
    id: row.event_id ?? `${row.phone}-${row.goal}-${row.created_at}`,
  }));
}
